export const scrollToId = (id, options = {behavior: 'smooth'}) =>
  document.getElementById(id)?.scrollIntoView(options);

export const scrollToSelector = (querySelector, options = {behavior: 'smooth'}) =>
  document.querySelector(querySelector)?.scrollIntoView(options);

export const scrollToTop = (options = {}) => {
  if(process.env.BROWSER && window) {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
      ...options
    });
  }
};
